(function() {
    'use strict';

    angular
        .module('quilinkApp')
        .controller('DiscoverController', DiscoverController);

    DiscoverController.$inject = ['$scope', '$timeout', '$rootScope', 'Principal', 'Suggestions', 'Discover', 'Connexion'];

    function DiscoverController($scope, $timeout, $rootScope, Principal, Suggestions, Discover, Connexion) {
        var vm = this;

        vm.suggestions = [];
        vm.suggestionsDone = [];
        vm.profileToConnect = null;
        vm.page = 1;
        vm.itemsPerPage = 1;
        vm.flowIndex = 0;
        vm.connectMosaic = connectMosaic;
        vm.connectFlow = connectFlow;
        vm.cardFlowClass = cardFlowClass;
        vm.pageConnexion = 0;
        vm.hasNextPageConnexion = true;
        vm.connexionsParPage = 21;
        
         vm.loadMoreConnexions = loadMoreConnexions;

        loadMoreConnexions();
        //getBatchSuggestions();

        $rootScope.$on('keypress', function(onEvent, keypressEvent) {
            if (keypressEvent.which === 116) {
                // T
                connectFlow(vm.suggestions[vm.flowIndex], 1);
            } else if (keypressEvent.which === 102) {
                // F
                connectFlow(vm.suggestions[vm.flowIndex], 2);
            } else if (keypressEvent.which === 106) {
                // J
                connectFlow(vm.suggestions[vm.flowIndex], 3);
            } else if (keypressEvent.which === 120) {
                // X
                vm.flowIndex = Math.max(vm.flowIndex - 1, 0);
                $scope.$apply();
            }
        });

        function getBatchSuggestions() {
            Suggestions.get(60).then(function (results) {
                vm.suggestions = results;
            });
        }


        function loadMoreConnexions(reset) {

            var excludesIds = vm.suggestions.map(function (a) {
                return a.id;
            });
            
            if (reset) vm.pageConnexion = 0;
            
            // N010 "Si on peut changer ce nombre de sorte à avoir tjs un seul profil sur la derniere ligne de profil chargée.""
            if (vm.pageConnexion == 0){
                vm.connexionsParPage = 19;
            } else {
                 vm.connexionsParPage = 21;
            }

            Discover.getList({
                excludes : excludesIds,
                page: vm.pageConnexion,
                size: vm.connexionsParPage
            }, function (results) {
                if (reset) {
                    vm.suggestions = [];
                }
                results.forEach(function (suggestion) {
                    vm.suggestions.push(suggestion);
                });
            });
            vm.pageConnexion += 1;
        }

        function connectMosaic(profileId, grade) {
            vm.profileToConnect = profileId;
            var connection = {
                creator: {
                    id: Principal.profile.id
                },
                grade: grade,
                target: {
                    id: profileId
                }
            };
            Connexion.save(connection, onSaveSuccess, angular.noop);

            function onSaveSuccess() {
                vm.suggestions = vm.suggestions.filter(function (profile) {
                    return profile.id !== vm.profileToConnect;
                });
                /*
                if (vm.suggestions.length > 18) {
                    vm.suggestions = vm.suggestions.slice(0, 18);
                } else {
                    //getBatchSuggestions();
                }
                */
            }
        }

        function connectFlow(people, grade) {
            // Update layout
            people.grade = grade;
            var connection = {
                creator: {
                    id: Principal.profile.id
                },
                grade: grade,
                target: {
                    id: people.id
                }
            };
            Connexion.save(connection, onSaveSuccess, angular.noop);

            function onSaveSuccess() {
                var len = vm.suggestions.length;
                vm.flowIndex = Math.min(len - 1, vm.flowIndex + 1);

                // if (vm.flowIndex === len - 2) {
                //     getBatchSuggestions();
                // }
            }
        }

        function cardFlowClass(index, focusIndex) {
            return {
                'flow-left-out' : index < focusIndex - 2,
                'flow-left-left' : index === focusIndex - 2,
                'flow-left' : index === focusIndex - 1,
                'flow-center' : index === focusIndex,
                'flow-right' : index === focusIndex + 1,
                'flow-right-right': index === focusIndex + 2,
                'flow-right-out' : index > focusIndex + 2
            }
        }
    }
})();
